import { Component, OnInit } from '@angular/core';

import { StorageKeyEnum } from '@app/core/enums/storage-key.enum';
import { StorageService } from '@app/core/services/storage.service';

@Component({
  selector: 'app-gdrp-popup',
  templateUrl: './gdrp-popup.component.html',
  styleUrls: ['./gdrp-popup.component.scss'],
})
export class GdrpPopupComponent implements OnInit {
  public gdrpIsShow = true;
  constructor(private storageService: StorageService) {}

  ngOnInit(): void {
    const gdrpExists = this.storageService.getStorageItem(StorageKeyEnum.GDRP);
    if (gdrpExists) {
      this.gdrpIsShow = false;
    }
  }

  gotIt(): void {
    this.storageService.setStorageItem(StorageKeyEnum.GDRP, true);
    this.gdrpIsShow = false;
  }
}
